import { UnloadedFuelDataResolved } from "./unloaded-fuel-data-resolved";

export interface UpdateUnloadedFuelDataResolvedRequest {
    dataToUpdate: UnloadedFuelDataResolved[];
}